import { usePageTitle } from '@/_shared/hooks/usePageTitle';

import { AiControlsSection } from './SettingsAiControls';
import { SettingsLinkedRepos } from './SettingsLinkedRepos';
import { ScmSection } from './SettingsScm';

export function SettingsContext(): React.ReactElement {
  usePageTitle('Context — Settings');

  return (
    <div className="flex flex-col gap-10">
      <AiControlsSection />
      <ScmSection />
      <SettingsLinkedRepos />
    </div>
  );
}
